import { Box, Tooltip } from "@mui/joy";
import DarkTypography from "components/common/DarkTypography";
import { SInfo } from "styles/StyledMUI";
import {
  formatSMSUnicodeTriggersHint,
  getSMSCharsPerSegment,
  getSMSDispatchTotal,
  getSMSLengthInfo,
  smsTextHasPlaceholders,
} from "./smsLength";

type SMSLengthLabelProps = {
  text: string;
  dispatchCount?: number;
};

export default function SMSLengthLabel(props: SMSLengthLabelProps) {
  const { text, dispatchCount } = props;
  const info = getSMSLengthInfo(text);
  const approxPrefix = smsTextHasPlaceholders(text) ? "~" : "";
  const mode = info.unicode ? "Unicode" : "GSM";
  const perSms = getSMSCharsPerSegment(info);
  const smsLabel = info.segments <= 1 ? "1 SMS" : `${info.segments} SMS`;
  const unicodeHint = info.unicode ? formatSMSUnicodeTriggersHint(text) : null;
  const totalSms =
    dispatchCount != null && dispatchCount > 0 ? getSMSDispatchTotal(text, dispatchCount) : 0;

  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        flexWrap: "wrap",
        gap: 0.35,
        minWidth: 0,
        justifyContent: "flex-end",
      }}
    >
      <DarkTypography level="body-xs" colorVariant="legend" component="span">
        {approxPrefix}
        {info.units} car. · {mode}
      </DarkTypography>
      {unicodeHint ? (
        <Tooltip title={unicodeHint} placement="top" sx={{ maxWidth: 320 }}>
          <Box
            component="span"
            sx={{
              display: "inline-flex",
              alignItems: "center",
              cursor: "help",
              color: "inherit",
              lineHeight: 0,
            }}
            aria-label={unicodeHint}
          >
            <SInfo sx={{ fontSize: 15 }} />
          </Box>
        </Tooltip>
      ) : null}
      <DarkTypography level="body-xs" colorVariant="legend" component="span">
        · {approxPrefix}
        {smsLabel} ({perSms}/SMS)
      </DarkTypography>
      {totalSms > 0 ? (
        <DarkTypography level="body-xs" colorVariant="legend" component="span">
          · {approxPrefix}
          {totalSms} SMS au total
        </DarkTypography>
      ) : null}
    </Box>
  );
}
